import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Clear from '@material-ui/icons/Clear'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FormLabel from '@material-ui/core/FormLabel'
import FormGroup from '@material-ui/core/FormGroup'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import EnergyAPI from 'config/api/EnergyAPI'
import { onError } from 'config/lib/errorLib'
import { eeProductOptions } from 'config/constants/Constants'

import componentStyles from 'assets/theme/views/admin/notifications.js'
import componentStylesDialog from 'assets/theme/components/dialog.js'

const useStyles = makeStyles(componentStyles)
const useStylesDialog = makeStyles(componentStylesDialog)

const ALL_IRISH_COUNTIES = [
    'Carlow','Cavan','Clare','Cork','Donegal','Dublin',
    'Galway','Kerry','Kildare','Kilkenny','Laois','Leitrim',
    'Limerick','Longford','Louth','Mayo','Meath','Monaghan',
    'Offaly','Roscommon','Sligo','Tipperary','Waterford',
    'Westmeath','Wexford','Wicklow'
]

const SOURCE_LABELS = { ee: 'Energy Efficiency (EE)', sf: 'Solar Finder (SF)' }

const Transition = React.forwardRef(function Transition(props, ref) {
  	return <Slide direction='down' ref={ref} {...props} />
})

export default function AddEnergyDeliveryModal(props) {
	const classes = {...useStyles(), ...useStylesDialog()}
  	const api = new EnergyAPI()

	const companies = props.companies

    const [company, setCompany] = useState('')
    const [product, setProduct] = useState('')
    const [leadPrice, setLeadPrice] = useState(0)
    const [deliveryTypes, setDeliveryTypes] = useState(['webhook'])
    const [webhook, setWebhook] = useState('')
    const [deliveryEmail, setDeliveryEmail] = useState('')
    const [solarStackWebhook, setSolarStackWebhook] = useState('')
    const [privyrWebhook, setPrivyrWebhook] = useState('')
    const [weeklyCap, setWeeklyCap] = useState('')
    const [minEELeads, setMinEELeads] = useState('')
    const [eeLeadMode, setEeLeadMode] = useState('')
    const [active, setActive] = useState(true)
    const [priority, setPriority] = useState(false)
    const [surgeEnabled, setSurgeEnabled] = useState(false)
    const [surgePercent, setSurgePercent] = useState('')
    const [weekendLeads, setWeekendLeads] = useState(true)
    const [businessHoursOnly, setBusinessHoursOnly] = useState(false)
    const [rejectDuplicates, setRejectDuplicates] = useState(false)
    const [hkCommission, setHkCommission] = useState(false)
    const [preHkLeads, setPreHkLeads] = useState(0)
    const [billingCompanyId, setBillingCompanyId] = useState('')
    // Per-source overrides: { ee: {...}, sf: {...} }
    const [sourceOverrides, setSourceOverrides] = useState({
        ee: { enabled: false, leadPrice: '', weeklyCap: '', counties: [] },
        sf: { enabled: false, leadPrice: '', weeklyCap: '', counties: [] }
    })

    function setOverrideField(src, field, value) {
        setSourceOverrides(prev => ({
            ...prev,
            [src]: { ...prev[src], [field]: value }
        }))
    }

    function buildSourceOverridesPayload() {
        const out = {}
        for (const src of ['ee', 'sf']) {
            const ov = sourceOverrides[src]
            if (!ov || !ov.enabled) continue
            out[src] = {
                leadPrice: ov.leadPrice === '' ? null : parseFloat(ov.leadPrice),
                weeklyCap: ov.weeklyCap === '' ? null : parseInt(ov.weeklyCap),
                counties: Array.isArray(ov.counties) ? ov.counties : []
            }
        }
        return Object.keys(out).length ? out : null
    }

  	async function addDelivery() {
		let selectedCompany = companies.find(item => item.companyId === company)
		console.log('company: ', selectedCompany) 

		try {   
			let delivery = await api.addEnergyDelivery(
				selectedCompany.companyId, 
				selectedCompany.name, 
				product, 
				leadPrice, 
				deliveryTypes.includes('webhook') ? (webhook || null) : null,
				deliveryTypes.includes('email') ? (deliveryEmail || null) : null,
				deliveryTypes.includes('solarStack') ? (solarStackWebhook || null) : null,
				deliveryTypes.includes('privyr') ? (privyrWebhook || null) : null,
				weeklyCap === '' ? null : parseInt(weeklyCap), 
				active,
				minEELeads === '' ? null : parseInt(minEELeads),
				eeLeadMode || null,
				priority,
				surgeEnabled,
				surgePercent === '' ? null : parseInt(surgePercent),
				weekendLeads,
				businessHoursOnly,
				hkCommission,
				preHkLeads === '' ? 0 : parseInt(preHkLeads),
				billingCompanyId || null,
				buildSourceOverridesPayload(),
				rejectDuplicates
			)
			console.log('delivery: ', delivery)

			props.refreshDeliveries()
			props.showSuccessAlert('Delivery added!')
			props.close()
		} catch(e) {
			onError(e)
		}
  	}

  	function checkFields() {
  		if (company.length > 0 && product.length > 0) {
  			return false
  		}
  		else {
  			return true
  		}
  	}

	return (
		<Dialog
			open={props.isOpen}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => props.close()}
		>
			<div className={classes.dialogHeader}>
				<Typography
					variant='h5'
					component='h5'
					className={classes.dialogTitle}
				>
					Add Energy Delivery
				</Typography>
				<IconButton onClick={() => props.close()}>
					<Clear />
				</IconButton>
			</div>

			<DialogContent>
                <FormGroup>
                    <FormLabel>Company</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={company}
                            onChange={(e) => setCompany(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            {companies.map((company) => (
                                <MenuItem key={company.companyId} value={company.companyId}>{company.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Product</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={product}
                            onChange={(e) => setProduct(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            {eeProductOptions.map((product) => (
                                <MenuItem key={product.value} value={product.value}>{product.label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Lead Price (€)</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='number'
                        value={leadPrice}
                    	onChange={(e) => setLeadPrice(e.target.value)}
                  	/>
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Delivery Type</FormLabel>
                  	<FormControl variant='outlined' fullWidth>
                        <Select
                            multiple
                            value={deliveryTypes}
                            onChange={(e) => {
                                const next = e.target.value
                                setDeliveryTypes(product === 'Solar' ? next : next.filter(v => v !== 'solarStack' && v !== 'privyr'))
                            }}
                            input={<OutlinedInput />}
                            renderValue={(selected) => selected.map(v => v === 'webhook' ? 'Webhook' : v === 'email' ? 'Email' : v === 'privyr' ? 'Privyr' : 'SolarStack').join(', ')}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value='webhook'>Webhook</MenuItem>
                            <MenuItem value='email'>Email</MenuItem>
                            {product === 'Solar' && (
                                <MenuItem value='solarStack'>SolarStack</MenuItem>
                            )}
                            {product === 'Solar' && (
                                <MenuItem value='privyr'>Privyr</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </FormGroup>
                {deliveryTypes.includes('webhook') && (
                    <FormGroup>
                      	<FormLabel>Webhook URL</FormLabel>
                      	<OutlinedInput
                        	fullWidth
                        	type='text'
                            value={webhook}
							placeholder='https://hooks.zapier.com/...'
                        	onChange={(e) => setWebhook(e.target.value)}
                      	/>
                    </FormGroup>
                )}
                {deliveryTypes.includes('email') && (
                    <FormGroup>
                      	<FormLabel>Delivery Email</FormLabel>
                      	<OutlinedInput
                        	fullWidth
                        	type='text'
                            value={deliveryEmail}
							placeholder='e.g. leads@company.ie, manager@company.ie'
                        	onChange={(e) => setDeliveryEmail(e.target.value)}
                      	/>
                    </FormGroup>
                )}
                {deliveryTypes.includes('solarStack') && product === 'Solar' && (
                    <FormGroup>
                      	<FormLabel>SolarStack Webhook URL</FormLabel>
                      	<OutlinedInput
                        	fullWidth
                        	type='text'
                            value={solarStackWebhook}
							placeholder='https://api.solarstack.io/...'
                        	onChange={(e) => setSolarStackWebhook(e.target.value)}
                      	/>
                    </FormGroup>
                )}
                {deliveryTypes.includes('privyr') && product === 'Solar' && (
                    <FormGroup>
                      	<FormLabel>Privyr Webhook URL</FormLabel>
                      	<OutlinedInput
                        	fullWidth
                        	type='text'
                            value={privyrWebhook}
							placeholder='https://www.privyr.com/api/v1/incoming-leads/...'
                        	onChange={(e) => setPrivyrWebhook(e.target.value)}
                      	/>
                    </FormGroup>
                )}
				<FormGroup>
					<FormLabel>Weekly Cap</FormLabel>
					<OutlinedInput
						fullWidth
						type='number'
						value={weeklyCap}
						placeholder='Leave blank for unlimited'
						onChange={(e) => setWeeklyCap(e.target.value)}
					/>
					<Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
						Leave blank for unlimited (no cap)
					</Box>
				</FormGroup>
				{product === 'Solar' && (
					<FormGroup>
						<FormLabel>Source Overrides</FormLabel>
						<Box fontSize='11px' color='#8898aa' marginBottom='0.5rem'>
							Optionally give a specific lead source its own price, weekly cap and counties. Sources without an override use the base Lead Price / Weekly Cap / coverage above. Each override is billed and capped independently.
						</Box>
						{['ee', 'sf'].map((src) => {
							const ov = sourceOverrides[src]
							return (
								<Box key={src} border='1px solid #e9ecef' borderRadius='4px' padding='0.75rem' marginBottom='0.5rem'>
									<label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>
										<input
											type='checkbox'
											checked={ov.enabled}
											onChange={(e) => setOverrideField(src, 'enabled', e.target.checked)}
										/>
										{SOURCE_LABELS[src]} override
									</label>
									{ov.enabled && (
										<Box marginTop='0.5rem'>
											<Box display='flex' style={{ gap: '8px' }}>
												<Box flex='1'>
													<FormLabel style={{ fontSize: '12px' }}>Lead Price (€)</FormLabel>
													<OutlinedInput
														fullWidth
														type='number'
														value={ov.leadPrice}
														placeholder='Base price'
														onChange={(e) => setOverrideField(src, 'leadPrice', e.target.value)}
													/>
												</Box>
												<Box flex='1'>
													<FormLabel style={{ fontSize: '12px' }}>Weekly Cap</FormLabel>
													<OutlinedInput
														fullWidth
														type='number'
														value={ov.weeklyCap}
														placeholder='Unlimited'
														onChange={(e) => setOverrideField(src, 'weeklyCap', e.target.value)}
													/>
												</Box>
											</Box>
											<Box marginTop='0.5rem'>
												<FormLabel style={{ fontSize: '12px' }}>Counties</FormLabel>
												<FormControl variant='outlined' fullWidth>
													<Select
														multiple
														value={ov.counties}
														onChange={(e) => setOverrideField(src, 'counties', e.target.value)}
														renderValue={(selected) => selected.length ? selected.join(', ') : 'Select counties'}
														displayEmpty
													>
														{ALL_IRISH_COUNTIES.map((c) => (
															<MenuItem key={c} value={c}>{c}</MenuItem>
														))}
													</Select>
												</FormControl>
												<Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
													Only leads from {SOURCE_LABELS[src]} in these counties go to this delivery. Leave empty to use the base coverage for this source.
												</Box>
											</Box>
										</Box>
									)}
								</Box>
							)
						})}
					</FormGroup>
				)}
				<FormGroup>
					<FormLabel>Min EE Leads</FormLabel>
					<OutlinedInput
						fullWidth
						type='number'
						value={minEELeads}
						placeholder='Leave blank for none'
						onChange={(e) => setMinEELeads(e.target.value)}
					/>
					<Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
						Minimum EE leads to prioritise before normal allocation. Leave blank for none.
					</Box>
				</FormGroup>
				{minEELeads !== '' && parseInt(minEELeads) > 0 && (
					<FormGroup>
						<FormLabel>EE Lead Mode</FormLabel>
						<FormControl variant='outlined' fullWidth>
							<Select
								multiple={false}
								value={eeLeadMode || 'mixed'}
								onChange={(e) => setEeLeadMode(e.target.value)}
								input={<OutlinedInput />}
								style={{marginBottom: '0.5rem'}}
							>
								<MenuItem value='first'>EE First — block SF until min EE met</MenuItem>
								<MenuItem value='mixed'>Mixed — EE sprinkled with SF</MenuItem>
							</Select>
						</FormControl>
						<Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
							'EE First' gets 3× priority for EE leads and blocks SF until target met. 'Mixed' receives both throughout.
						</Box>
					</FormGroup>
				)}
                <FormGroup>
                    <FormLabel>Active</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={active}
                            onChange={(e) => setActive(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Priority</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={priority}
                            onChange={(e) => setPriority(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                        When enabled, only this provider (and other active priority providers) will receive leads in their coverage area. Non-priority providers are excluded from the pool entirely.
                    </Box>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Weekend Leads</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={weekendLeads}
                            onChange={(e) => setWeekendLeads(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                        When disabled, this delivery will not receive leads on Saturdays and Sundays.
                    </Box>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Business Hours Only</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={businessHoursOnly}
                            onChange={(e) => setBusinessHoursOnly(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                            disabled={weekendLeads !== false}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                        When enabled, this delivery only receives leads Mon–Fri between 08:00–18:00 Ireland time. Requires Weekend Leads to be set to No.
                    </Box>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Reject Duplicates</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={rejectDuplicates}
                            onChange={(e) => setRejectDuplicates(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                        When enabled, a repeat lead from the same person within the duplicate window is rejected instead of being re-sent to this delivery. Default (No) re-sends duplicates as free leads.
                    </Box>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Surge</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={surgeEnabled}
                            onChange={(e) => {
                                setSurgeEnabled(e.target.value)
                                if (!e.target.value) setSurgePercent('')
                            }}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Enabled</MenuItem>
                            <MenuItem value={false}>Disabled</MenuItem>
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                        When enabled, allows flexible over/under delivery by a percentage of the weekly cap. The difference carries over to adjust next week's cap.
                    </Box>
                </FormGroup>
                {surgeEnabled && (
                    <FormGroup>
                        <FormLabel>Surge % (of weekly cap)</FormLabel>
                        <OutlinedInput
                            fullWidth
                            type='number'
                            value={surgePercent}
                            placeholder='e.g. 10 for ±10%'
                            onChange={(e) => setSurgePercent(e.target.value)}
                        />
                        <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                            Percentage of weekly cap allowed as surge. E.g. 10% on a cap of 160 = ±16 leads flexibility.
                        </Box>
                    </FormGroup>
                )}
                <FormGroup>
                    <FormLabel>HK Commission</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={hkCommission}
                            onChange={(e) => setHkCommission(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                        When enabled, HK commission is calculated for this delivery.
                    </Box>
                </FormGroup>
                {hkCommission && (
                    <FormGroup>
                        <FormLabel>Pre-HK Leads (per week)</FormLabel>
                        <OutlinedInput
                            fullWidth
                            type='number'
                            value={preHkLeads}
                            placeholder='e.g. 10'
                            onChange={(e) => setPreHkLeads(e.target.value)}
                        />
                        <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                            Leads this provider was already taking per week before HK got involved. HK commission is calculated on leads above this number.
                        </Box>
                    </FormGroup>
                )}
                <FormGroup>
                    <FormLabel>Billing Company</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={billingCompanyId}
                            onChange={(e) => setBillingCompanyId(e.target.value)}
                            input={<OutlinedInput />}
                            displayEmpty
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value=''>Same as delivery company (default)</MenuItem>
                            {companies
                                .filter((c) => c.companyId !== company)
                                .map((c) => (
                                    <MenuItem key={c.companyId} value={c.companyId}>{c.name}</MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginTop='0.25rem'>
                        Bill this delivery's leads to a different company (parent/payer). Leave as default to bill the delivery company itself.
                    </Box>
                </FormGroup>
			</DialogContent>
			
			<DialogActions>
				<Button
					onClick={() => props.close()}
					color='primary'
				>
					Cancel
				</Button>
			
				<Button
					component={Box}
					onClick={() => addDelivery()}
					color='primary'
					marginLeft='auto!important'
					variant='contained'
					disabled={checkFields()}
				>
					Add
				</Button>
			</DialogActions>
		</Dialog>
	)
}
